import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import axios from "@/axios/request";
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import BootstrapVue from "bootstrap-vue";
import 'font-awesome/css/font-awesome.min.css';
import VueClipboard from "vue-clipboard2";
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import './plugins/mixin'

Vue.use(VueClipboard)
Vue.use(VueVideoPlayer)
Vue.use(ElementUI, { locale })
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import router from '@/router/index'
// import axios from "axios";
Vue.prototype.axios = axios

Vue.use(ElementUI);
import global_ from './components/common'//引用全局变量
Vue.prototype.common = global_//挂载到Vue实例上面
Vue.config.productionTip = false

const vm = new Vue({
  data: {
    // 判断是否登录
    isLogin: false,
  },
  router,
  render: h => h(App),
}).$mount('#app')
axios.vm = vm

// request(vm)
